import styled from 'styled-components'

export const StyledContactCard = styled.div`
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  padding: ${({ theme }) => theme.spacing.large};
`

export const ContactHeader = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.large};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.medium};
`

export const ContactTitle = styled.h3`
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`

export const MandateBadge = styled.div<{ $type?: string }>`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xsmall};
  padding: ${({ theme }) => theme.spacing.xsmall}
    ${({ theme }) => theme.spacing.small};
  background: ${({ theme, $type }) => {
    switch ($type) {
      case 'exclusive':
        return theme.colors.tags.blue
      case 'shared':
        return theme.colors.tags.orange
      default:
        return theme.colors.tags.gray
    }
  }};
  color: ${({ theme, $type }) => {
    switch ($type) {
      case 'exclusive':
        return theme.colors.primary
      case 'shared':
        return theme.colors.warning
      default:
        return theme.colors.text.tertiary
    }
  }};
  border-radius: ${({ theme }) => theme.borderRadius.round};
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  text-transform: capitalize;
`

export const ContactsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
`

export const ContactItem = styled.div<{ $clickable?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.default};
  padding: ${({ theme }) => theme.spacing.default};
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  transition: all ${({ theme }) => theme.transitions.fast};
  ${({ $clickable }) => $clickable && 'cursor: pointer;'}

  &:hover {
    border-color: ${({ theme, $clickable }) =>
      $clickable ? theme.colors.primary : theme.colors.border.default};
    box-shadow: ${({ theme }) => theme.shadows.sm};
    ${({ $clickable, theme }) =>
      $clickable &&
      `
      background: ${theme.colors.background.secondary};
    `}
  }
`

export const ContactAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: ${({ theme }) => theme.borderRadius.circle};
  background: ${({ theme }) => theme.colors.background.tertiary};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  svg {
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`

export const ContactInfo = styled.div`
  flex: 1;
  min-width: 0;
`

export const ContactName = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ContactRole = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  color: ${({ theme }) => theme.colors.text.tertiary};
  text-transform: uppercase;
  letter-spacing: ${({ theme }) => theme.typography.letterSpacing.uppercase};
`

export const ContactActions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
`
